import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Button as DefaultButton, Text } from '@simplywallst/ui-core';

type Severity = 'minor' | 'major' | 'none' | null;

interface BlockquoteProps {
  severity?: Severity;
  size: 'small' | 'default';
}

const color = css<{ severity?: Severity }>`
  ${({ severity, theme }) => {
    switch (severity) {
      case 'major':
        return theme.color.bad;
      case 'minor' || 'none':
        return theme.color.warning;
      default:
        return theme.color.good;
    }
  }};
`;

export const Wrapper = styled('blockquote')<BlockquoteProps>`
  position: relative;
  display: flex;
  align-items: top;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  padding-left: ${({ theme }) => theme.x4spacePx}px;
`;

export const StyledText = styled(Text)<BlockquoteProps>`
  margin-top: ${({ size }) => (size === 'small' ? -1 : 2)}px;
  ${media.lgUp`
    margin-top: -2px;
  `}
`;

export const IconWrapper = styled('div')<BlockquoteProps>`
  position: absolute;
  left: 0;
  padding: ${({ theme }) => theme.x1spacePx / 2}px;
  > svg {
    position: absolute;
    top: ${({ size }) => (size === 'small' ? -4 : 0)}px;
    left: 0;
    fill: ${color};
  }
  ${({ severity, theme, size }) =>
    severity &&
    severity !== 'none' &&
    css`
      &:before {
        content: '';
        display: block;
        background-color: ${theme.color.white};
        border-radius: ${({ theme }) => theme.x3spacePx}px;
        width: 14px;
        height: 14px;
        margin: 1px;
        margin-top: ${size === 'small' ? -3 : 1}px;
      }
    `}
`;

export const Button = styled(DefaultButton)`
  box-shadow: none;
  > svg {
    margin-right: -${({ theme }) => theme.x1spacePx}px;
  }
  &:hover {
    > svg {
      transform: rotate(90deg);
    }
  }
`;
